module.exports = __webpack_public_path__ + "img/BGN.c3d7d066.svg";